import { connect } from 'react-redux';

const mapStateToProps = ({ NewOrderReducer }) => ({
  $state: {
    orderData: { ...NewOrderReducer.orderData, conditions: NewOrderReducer.device.conditions },
    customer: {
      ...NewOrderReducer.customer,
      billing: NewOrderReducer.billingAddress,
    },
  },
});

export default connect(mapStateToProps);
